<template lang="pug">
    authorized-layout
        template(v-slot:main-content)
            construction-block.mb-2
                tab-navigation(:items="navigationItems")
            router-view
</template>

<script>
import AuthorizedLayout from '@/layouts/authorized-layout';
import TabNavigation from '@/components/common/tab-navigation';
import ConstructionBlock from '@/components/common/block';
import { TABS_NAVIGATION } from '@/configs/names.js'

export default {
    name: "PromotionsPage",
    components: {
        'authorized-layout': AuthorizedLayout,
        'tab-navigation': TabNavigation,
        'construction-block': ConstructionBlock,
    },
    computed: {
        navigationItems() {
            return [
                { route: '/promotions/list', name: TABS_NAVIGATION.list },
            ]
        }
    }
}
</script>
